// src/i18n/locales.ts
import { enUS, es as dfEs, ptBR, zhCN } from 'date-fns/locale'
import type { Locale } from 'date-fns'

export const SOURCE_LOCALE = 'en'
export const SUPPORTED_LOCALES = ['en', 'zh', 'pt', 'es'] as const
export type AppLocale = (typeof SUPPORTED_LOCALES)[number]

/** 语言选择器显示 endonym（UI 文案规范的明确例外） */
export const LOCALE_ENDONYMS: Record<AppLocale, string> = {
  en: 'English',
  zh: '中文',
  pt: 'Português',
  es: 'Español',
}

export const LOCALE_STORAGE_KEY = 'novaLocale'
/** help 中心已有的语言记忆 key，切语言时联动写入 */
export const HELP_LANG_STORAGE_KEY = 'novaHelpLang'

export const DAYJS_LOCALES: Record<AppLocale, string> = {
  en: 'en', zh: 'zh-cn', pt: 'pt-br', es: 'es',
}

const DATE_FNS_LOCALES: Record<AppLocale, Locale> = {
  en: enUS, zh: zhCN, pt: ptBR, es: dfEs,
}

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

export function getDateFnsLocale(locale: string): Locale {
  return isAppLocale(locale) ? DATE_FNS_LOCALES[locale] : enUS
}

/** 启动时同步解析初始语言：localStorage > navigator.language 前缀 > en */
export function resolveInitialLocale(
  stored: string | null,
  navigatorLanguage: string | undefined,
): AppLocale {
  if (isAppLocale(stored)) return stored
  const prefix = navigatorLanguage?.split('-')[0]
  if (isAppLocale(prefix)) return prefix
  return SOURCE_LOCALE
}
